import { createContext } from 'react';

import { TAiPageChatMessageDto, TAiReviewPageMessageChatDto } from '@app-velocity/av-api-v2';

export type DiscussionSendPayload = Pick<
  TAiReviewPageMessageChatDto,
  | 'question'
  | 'challenge'
  | 'takenAction'
  | 'element'
  | 'explanation'
  | 'discussion'
>;

export type DiscussionContextValue = {
  messages?: TAiPageChatMessageDto[];
  isLoadingMessages: boolean;
  isSending: boolean;
  isReady: boolean;
  sendQuestion: (payload: DiscussionSendPayload) => Promise<void>;
};

export const DiscussionContext = createContext<DiscussionContextValue>({
  messages: undefined,
  isLoadingMessages: false,
  isSending: false,
  isReady: false,
  sendQuestion: async () => undefined,
});
